import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { HomeContent } from '@shared/types';

export const DEFAULT_HOME_CONTENT: HomeContent = {
  id: 'home',
  heroImageUrl: '/home-hero.jpg',
  heroEyebrow: 'Kerala Festivals',
  heroTitle: 'Experience the magic of',
  heroTitleHighlight: 'Pooram',
  heroSubtitle:
    "Discover, plan and immerse yourself in Kerala's vibrant temple festivals with real-time updates, live streams, and community features.",
  heroSearchPlaceholder: 'Search festivals, temples, or elephants',
  heroPrimaryCtaLabel: 'Use my location',
  heroPrimaryCtaPath: '/map',
  heroSecondaryCtaLabel: 'Browse calendar',
  heroSecondaryCtaPath: '/directory',
  sectionLiveHighlight: true,
  sectionNearby: true,
  sectionCountdown: true,
  sectionDistricts: true,
  sectionGuide: true,
  sectionPhotos: true,
  sectionMap: true,
  titleNearby: 'Nearby Festivals',
  titleCountdown: 'Upcoming Festivals',
  titleDistricts: 'Explore by Districts',
  titleGuide: 'Festival Guide & Resources',
  titlePhotos: 'Community Photos',
  titleMap: 'Festival Map',
  guideVisitor: '',
  guideEtiquette: '',
  guideTravel: '',
  guideSafety: '',
  footerTagline: 'Made with ❤️ for Kerala.',
};

export function useHomeContent() {
  const { data } = useQuery({
    queryKey: ['home-content'],
    queryFn: () => api<HomeContent>('/api/home-content'),
    staleTime: 60 * 1000,
  });
  return { ...DEFAULT_HOME_CONTENT, ...(data ?? {}) } satisfies HomeContent;
}
